
//TODO: start requring components, dependencies, and helpers more modulrarly


/*
//Tabe component
*/
// const types = React.PropTypes;

const SORT_ORDER = {
    asc: 0,
    desc: 1,
    none: 2
};

const SORT_STRING = ["ascending","descending",null];

class Table extends React.Component {

    static propTypes = {
        columns: PropTypes.array.isRequired,
        CustomRow: PropTypes.func,
        data: PropTypes.array.isRequired,
        defaultSort: PropTypes.string,
        defaultorder: PropTypes.number,
        onChangeSort: PropTypes.func
    }

    static defaultProps = {
        onChangeSort: null
    }

    constructor(props, context) {
        super(props, context);
        const {columns, defaultSort, defaultorder} = props;
        const sortColumn = columns.find(({sortable, attribute}) => {
            return defaultSort ? attribute === defaultSort : sortable;
        });
        const sortOrder = defaultorder ? defaultorder : SORT_ORDER.asc;
        this.state = {sortColumn, sortOrder};
    }

    componentWillReceiveProps({columns, defaultSort, defaultorder}) {
        if (columns) {
            const sortColumn = columns.find(({sortable, attribute}) => {
                return defaultSort ? attribute === defaultSort : sortable;
            });
            const sortOrder = defaultorder ? defaultorder : SORT_ORDER.asc;
            this.setState({sortColumn, sortOrder});
        }
    }

    updateSort = (sortColumn, isSortColumn) => {
        //isSortColumn = current column being sorted by
        // console.info("updateSort called");
        // console.log(sortColumn,isSortColumn,this.state.sortOrder);
        const newOrder = isSortColumn ? ++this.state.sortOrder % Object.keys(SORT_ORDER).length : SORT_ORDER.asc;
        //console.log(newOrder);
        if(this.props.onChangeSort != null){
            this.props.onChangeSort(sortColumn.attribute, SORT_STRING[newOrder]);//pass values back to ObjectTable
        }
        this.setState({sortColumn, sortOrder: newOrder});
    }

    //sort rows inside plugin (no sort via data api query)
    sortedRows = data => {
        const {sortColumn, sortOrder} = this.state;
        if (sortOrder === SORT_ORDER.none) return this.rows(data);

        //console.info('sortedRows', sortColumn, sortOrder)

        var sortedData = _.sortBy(data,[function(datum){
            return datum[sortColumn.attribute];
        }]);

        if (sortOrder === SORT_ORDER.desc) sortedData.reverse();

        return this.rows(sortedData);
    }

    rows = data => {
        const {columns, CustomRow} = this.props;

        return data.map((datum, rowKey) => {
            const cells = columns.map(({attribute, CustomCell}, key) => {
                const Cell = CustomCell || TableCell;
                return <Cell key={key} index={rowKey} value={datum[attribute]} rowDatum={datum}>{datum[attribute]}</Cell>;
            });

            const Row = CustomRow || TableRow;
            return <Row key={rowKey} index={rowKey}>{cells}</Row>;
        });
    }

    renderHeaders = () => {
        const {sortColumn, sortOrder} = this.state;
        return this.props.columns.map((column, index) => {
            let {attribute, sortable, displayName, headerProps = {}, headerInfoText} = column;
            const isSortColumn = column === sortColumn;
            //console.log(sortColumn,column,isSortColumn);
            let className, icon;
            if (isSortColumn) {
                className = ['is-sorted-asc', 'is-sorted-desc', ''][sortOrder];
                icon = [<Icon classes="icon-sort-up"/>, <Icon classes="icon-sort-down"/>, null][sortOrder];
            }

            className = classNames(className, headerProps.className);

            headerProps = {
                ...headerProps,
                className,
                sortable,
                key: index,
                onSortableTableHeaderClick: () => this.updateSort(column, isSortColumn)
            };

            return <TableHeader {...headerProps}>
                <span>
                    {displayName || attribute}{icon}
                    {headerInfoText ? 
                        <Icon tabIndex="0" classes="icon-info-circle"  title={headerInfoText} /> : null}
                </span>
            </TableHeader>;
        });
    }

    render() {
        const {sortColumn,sortOrder} = this.state;
        let {columns, CustomRow, data, defaultSort, onChangeSort, ...props} = this.props;
        props = mergeProps(props, {className: ['table--sortable', 'table--full', 'table--responsive']});
        const rows = (sortColumn && onChangeSort == null) ? this.sortedRows(data) : this.rows(data);
        return (<table {...props}>
            <thead>
                <tr>{this.renderHeaders()}</tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </table>);
    }
}

class TableHeader extends React.Component {
    static propTypes = {
        onClick: PropTypes.func,
        onSortableTableHeaderClick: PropTypes.func,
        sortable: PropTypes.bool
    }

    handleActivate = event => {
        const {sortable, onClick, onSortableTableHeaderClick} = this.props;
        if (sortable) onSortableTableHeaderClick(event);
        if (onClick) onClick(event); //currently nothing is defining this prop but it's here just in case we want a generic header click function
    }

    handleKeyDown = event => {
        if (event.key === 'Enter') {
            this.handleActivate(event);
        }
    }

    render() {
        const {onSortableTableHeaderClick, sortable, ...others} = this.props;
        const props = mergeProps(others, {className: {'sortable': sortable}});

        const thProps = {...props, tabIndex: 0, disabled: !sortable};
        if (sortable) {
            return <th {...thProps} onClick={this.handleActivate} onKeyDown={this.handleKeyDown} role="button"/>;
        } else {
            return <th {...thProps}/>;
        }
    }
}

const TableCell = ({rowDatum, index, ...props}) => <td {...props}/>;

TableCell.propTypes = {
    index: PropTypes.number,
    rowDatum: PropTypes.any
};

const TableRow = ({index, ...props}) => <tr {...props}/>;

TableRow.propTypes = {
    index: PropTypes.number
};

//Pagination================
//https://github.com/eliseumds/react-paginate

var TablePagination = createReactClass({
    propTypes: {
        max: PropTypes.number.isRequired,
        maxVisible: PropTypes.number,
        onChange: PropTypes.func.isRequired
    },
    componentDidUpdate: function(prevProps, prevState) {
        if (prevState.currentPage !== this.state.currentPage) {
            //console.log("TablePagination componentDidUpdate cond true")
            this.props.onChange(this.state.currentPage);
        }
    },
    getDefaultProps: function() {
        return {
            maxVisible: 5
        };
    },
    getInitialState: function() {
        return {
            currentPage: 1,
            items: []
        };
    },
    goTo: function(page, e) {
        if (e) {
            e.preventDefault();
        }
        //console.log("goTo " + page)
        this.setState({currentPage: page});
    },

    onClickNext: function(e) {
        e.preventDefault();

        var page = this.state.currentPage;

        if (page < this.props.max) {
            this.goTo(page + 1);
        }
    },
    onClickPrev: function(e) {
        e.preventDefault();

        if (this.state.currentPage > 1) {
            this.goTo(this.state.currentPage - 1);
        }
    },
    render: function() {
        var className = this.props.className || '',
        p = this.props,
        s = this.state,
        skip = 0;

        if (s.currentPage > p.maxVisible - 1 && s.currentPage < p.max) {
            skip = s.currentPage - p.maxVisible + 1;
        } else if (s.currentPage === p.max && p.max >= p.maxVisible) {
            skip = s.currentPage - p.maxVisible;
        }

        var iterator = Array.apply(null, Array( ((p.max < p.maxVisible) ? p.max : p.maxVisible) )).map(function(v, i) {
            return skip + i + 1;
        });

        return (
            <nav role="navigation" aria-label="Pagination Navigation">
                <ul className={'group ' + className}>
                    <li className={'group-item ' + (s.currentPage === 1 ? 'is-disabled' : '')}>
                        <a href="#" onClick={this.goTo.bind(this, 1)}>
                            <span aria-hidden="true" className="icon-chevron-left icon--smaller"></span>
                            <span className="sr-only"> First</span>
                        </a>
                    </li>
                    <li className={'group-item ' + (s.currentPage === 1 ? 'is-disabled' : '')}>
                        <a href="#" onClick={this.onClickPrev}>
                            <span className="sr-only">Prev</span>
                        </a>
                    </li>
                    {iterator.map(function(page) {
                        return (
                            <li key={page}
                                onClick={this.goTo.bind(this, page)}
                                className={'group-item ' + (s.currentPage === page ? 'is-active' : '')}>
                                <a href="#" data-page={page} aria-current={(s.currentPage === page ? 'true' : 'false')}>{page}</a>
                            </li>
                        );
                    }, this)}
                    <li className={'group-item ' + (s.currentPage === p.max ? 'is-disabled' : '')}>
                        <a href="#" onClick={this.onClickNext}>
                            <span className="sr-only">Next</span>
                        </a>
                    </li>
                    <li className={'group-item ' + (s.currentPage === p.max ? 'is-disabled' : '')}>
                        <a href="#" onClick={this.goTo.bind(this, p.max)}>
                            <span className="sr-only">Last </span>
                            <span aria-hidden="true" className="icon-chevron-right icon--smaller"></span>
                        </a>
                    </li>
                </ul>
            </nav>
        );
    }
});
